import { render } from "./index.vue?vue&type=template&id=1f1491fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1f1491fd&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=1f1491fd&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1491fd"]])

export default __exports__